import { Component, EventEmitter, Output, OnDestroy, AfterViewInit } from '@angular/core';
import { UserService } from '@services/services.module';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ROL_TYPE } from '@app/constants/enums';
import { APP_URLS } from '@app/constants/app-urls';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnDestroy, AfterViewInit {

  @Output() toggleMiniSideBar = new EventEmitter();
  private subscriptions: Array<Subscription> = [];
  public userData: any;
  public showAdmin: boolean;
  public nameUser: number;
  public toogleList = false;
  public calendario = false;
  public empleado = false;
  public proyecto = false;
  public cliente = false;
  public menuHome = false;
  public menuImputation = false;
  public menuAdmin = false;

  constructor(
    private _router: Router,
    private _user: UserService
  ) {

  }

  ngAfterViewInit(): void {
    this.controlUsuario();
    setTimeout(() => {
      this.controlRouter();
    }, 300);
  }

  /**
   * Function to control the router and got to the page.
   * Used for menu option selection.
   */
  controlRouter(): void {
    const url = this._router.url ? this._router.url : '';
    if (this._router.url && this._router.url !== '') {
      const allRoutes = this._router.config;
      const activeRoute = allRoutes.find((route) => url.includes(route.path) && route.path !== '');
      if (activeRoute) {
        this.changeSelection(activeRoute.data.parent);
        this.goTo(url);
      }
    }
  }

  /**
   * Function to change the selection of the menu options
   * @param val Value of the parent router option
   */
  changeSelection(val) {
    switch (val) {
      case '':
        this.menuHome = true;
        this.menuImputation = false;
        this.menuAdmin = false;
        break;
      case APP_URLS.homePath:
        this.menuHome = true;
        this.menuImputation = false;
        this.menuAdmin = false;
        break;
      case APP_URLS.imputationPath:
        this.menuHome = false;
        this.menuImputation = true;
        this.menuAdmin = false;
        break;
      case APP_URLS.distributorPath:
        this.menuHome = false;
        this.menuImputation = false;
        this.menuAdmin = true;
        break;
    }
  }

  goTo(route: string): void {
    this._router.navigate([route]);
  }

  /**
   * Control de usuarios para mostrar/ocultar pestaña administrador
   */
  controlUsuario(): void {
    this._user.checkRolType([ROL_TYPE.admin, ROL_TYPE.manager, ROL_TYPE.operations, ROL_TYPE.direction]).then((data: any) => {
      this.showAdmin = data.value;
    });
  }

  clickMenuElem(route): void {
    if (window.innerWidth < environment.windowMinWidth) {
      this.toggleMiniSideBar.emit();
    }
    this.changeSelection(route);
    this.goTo(route);
  }

  classMenuHome(): string {
    return this.menuHome ? 'active' : '';
  }
  classMenuImputation(): string {
    return this.menuImputation ? 'active' : '';
  }
  classMenuAdmin(): string {
    return this.menuAdmin  ? 'active' : '';
  }

  /**
   * @name ngOnDestroy
   * @description Lifecycle hook
   */
  ngOnDestroy() {
    for (const subs of this.subscriptions) {
      subs.unsubscribe();
    }
  }
}
